(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-trust-icons"] && !Shopify.designMode) return;
  try {
    (() => {
    const moveBundleAfterTrustIcons = () => {
      document.querySelectorAll('.product-trust-icons').forEach((trustIcons) => {
        const scope = trustIcons.closest('.product-details') || trustIcons.closest('.product-information') || document;
        scope.querySelectorAll('.htusb-ui-prod-boost-under-form-wrapper').forEach((bundle) => {
          const position = bundle.compareDocumentPosition(trustIcons);

          if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            trustIcons.insertAdjacentElement('afterend', bundle);
          }
        });
      });
    };

    const scheduleMove = () => window.requestAnimationFrame(moveBundleAfterTrustIcons);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleMove, { once: true });
    } else {
      scheduleMove();
    }

    window.addEventListener('load', moveBundleAfterTrustIcons, { once: true });

    const observer = new MutationObserver(moveBundleAfterTrustIcons);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  })();
  } catch(e) { console.error(e); }
})();

})();
